import { useParams } from "react-router-dom";

import { useQuery } from "@tanstack/react-query";
import { Edge } from "@xyflow/react";

import { SATOSPortalNew } from "@/DataAdapter/Portal";

import {
	DiagramNodeResponse,
	NodeDiagramPublicityResponse,
} from "@/model/NodeDiagram/types";

import { RouteParams } from "@/service/Utilities";

export const useFetchNodeDiagramPublicity = () => {
	const { id } = useParams<RouteParams>();
	const procedureId = +id!;
	return useQuery<NodeDiagramPublicityResponse, any>({
		queryKey: [NodeDiagramQueryKeys.Publish, procedureId],
		queryFn: () => SATOSPortalNew.fetchNodeDiagramPublicity(procedureId),
		enabled: Boolean(id),
	});
};

export const useFetchNodeDiagramNodes = () => {
	const { id } = useParams<RouteParams>();
	const procedureId = +id!;
	return useQuery<DiagramNodeResponse[] | []>({
		queryKey: [NodeDiagramQueryKeys.Nodes, procedureId],
		queryFn: () => SATOSPortalNew.fetchNodeDiagramNodes(procedureId),
	});
};

export const useFetchNodeDiagramEdges = () => {
	const { id } = useParams<RouteParams>();
	const procedureId = +id!;
	return useQuery<Edge<any>[], any>({
		queryKey: [NodeDiagramQueryKeys.Edges, procedureId],
		queryFn: () => SATOSPortalNew.fetchNodeDiagramEdges(procedureId),
	});
};

export const useFetchNodeDiagramGroups = () => {
	const { id } = useParams<RouteParams>();
	const procedureId = +id!;
	return useQuery<DiagramNodeResponse[], any>({
		queryKey: [NodeDiagramQueryKeys.Groups, procedureId],
		queryFn: () => SATOSPortalNew.fetchNodeDiagramGroups(procedureId),
	});
};

export const NodeDiagramQueryKeys = {
	Nodes: "Diagram.Nodes",
	Edges: "Diagram.Edges",
	Groups: "Diagram.Groups",
	Publish: "Diagram.Publish",
};
